import React from 'react'
import PropTypes from 'prop-types'

import Layout from '../layouts'
import SEO from '../components/seo'
import Section from '../components/section'
import Container from '../components/container'

const PrivacyPolicyPage = (props) => {
  return (
    <Layout {...props} locale="en">
      <SEO title="Privacy Policy" />

      <Section>
        <Container maxWidth='780px'>
          {props.children}
        </Container>
      </Section>
    </Layout>
  )
}

PrivacyPolicyPage.propTypes = {
  children: PropTypes.node,
}

export default PrivacyPolicyPage
